export const Wrapper =
  'border-machine2-50 text-12 flex flex-row items-center justify-between border-b px-4 py-5 md:border'

export const StatItemWrapper = 'flex flex-col items-center'

export const StatItemSeparator = 'border-machine2-75 h-[30px] w-[1px] border-r'

export const StatLabel = 'text-grayRegular'

export const StatContent = ''

export const NoStats = 'text-grayRegular'
